import logo from './logo-reina-camino.png';

export default logo;
